import { render, staticRenderFns } from "./AddClassDialog.vue?vue&type=template&id=58dbe156&scoped=true&"
import script from "./AddClassDialog.vue?vue&type=script&lang=js&"
export * from "./AddClassDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddClassDialog.vue?vue&type=style&index=0&id=58dbe156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dbe156",
  null
  
)

export default component.exports